<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="代金券ID" prop="coinId" >
        <a-input v-model="form.coinId" placeholder="请输入代金券ID" />
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="类型 1 收入 2 支出" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="操作前金币余额" prop="beforeCoin" >
        <a-input v-model="form.beforeCoin" placeholder="请输入操作前金币余额" />
      </a-form-model-item>
      <a-form-model-item label="变动金币" prop="coin" >
        <a-input v-model="form.coin" placeholder="请输入变动金币" />
      </a-form-model-item>
      <a-form-model-item label="操作后金币余额" prop="afterCoin" >
        <a-input v-model="form.afterCoin" placeholder="请输入操作后金币余额" />
      </a-form-model-item>
      <a-form-model-item label="操作来源1-推广收益 2-兑换" prop="source" >
        <a-input v-model="form.source" placeholder="请输入操作来源1-推广收益 2-兑换" />
      </a-form-model-item>
      <a-form-model-item label="业务ID,当金币操作来源ID" prop="businessId" >
        <a-input v-model="form.businessId" placeholder="请输入业务ID,当金币操作来源ID" />
      </a-form-model-item>
      <a-form-model-item label="金币变动描述" prop="descr" >
        <a-input v-model="form.descr" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCoinRecord, addCoinRecord, updateCoinRecord } from '@/api/user/coinRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        coinId: null,

        userId: null,

        type: null,

        beforeCoin: null,

        coin: null,

        afterCoin: null,

        source: null,

        businessId: null,

        descr: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        coinId: [
          { required: true, message: '代金券ID不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型 1 收入 2 支出不能为空', trigger: 'change' }
        ],
        beforeCoin: [
          { required: true, message: '操作前金币余额不能为空', trigger: 'blur' }
        ],
        coin: [
          { required: true, message: '变动金币不能为空', trigger: 'blur' }
        ],
        afterCoin: [
          { required: true, message: '操作后金币余额不能为空', trigger: 'blur' }
        ],
        source: [
          { required: true, message: '操作来源1-推广收益 2-兑换不能为空', trigger: 'blur' }
        ],
        descr: [
          { required: true, message: '金币变动描述不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        coinId: null,
        userId: null,
        type: null,
        beforeCoin: null,
        coin: null,
        afterCoin: null,
        source: null,
        businessId: null,
        descr: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCoinRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCoinRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCoinRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
